import { isDefined } from "@clipboard-health/util-ts";
import { TextInput } from "@src/appV2/redesign/components/TextInput";
import { type FieldErrors, type UseFormRegister } from "react-hook-form";

import { type CredentialsFormData } from "../api/schema";
import { disabledInputTextSx } from "./shared";

interface UKGTimeclockCredentialsProps {
  register: UseFormRegister<CredentialsFormData>;
  errors: FieldErrors<CredentialsFormData>;
  externalIdErrorPlaceholder?: string;
}

export function UKGTimeclockCredentials({
  register,
  errors,
  externalIdErrorPlaceholder,
}: UKGTimeclockCredentialsProps) {
  return (
    <>
      <TextInput
        fullWidth
        label="UKG Person Number"
        InputLabelProps={{
          shrink: isDefined(externalIdErrorPlaceholder) ? true : undefined,
        }}
        // FIXME: Automatically disabled during ESLint config update
        error={Boolean(errors.externalId)}
        sx={isDefined(externalIdErrorPlaceholder) ? disabledInputTextSx : {}}
        helperText={errors.externalId?.message}
        disabled={isDefined(externalIdErrorPlaceholder)}
        placeholder={externalIdErrorPlaceholder}
        {...register("externalId")}
      />
      <TextInput
        fullWidth
        label="Time Clock Badge"
        // FIXME: Automatically disabled during ESLint config update
        error={Boolean(errors.timeclockBadge)}
        helperText={errors.timeclockBadge?.message}
        {...register("timeclockBadge")}
      />
    </>
  );
}
